import { createSlice } from "@reduxjs/toolkit";

const addModalSubQuestionCategorySlice = createSlice({
  name: "addModalSubQuestionCategory",
  initialState: {
    isOpen: false,
    error: null,
  },
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
      state.error = null;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.error = null;
    },
  },
});

export const { openModal, closeModal } = addModalSubQuestionCategorySlice.actions;
export default addModalSubQuestionCategorySlice.reducer;
